import produce from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.IReduxComponentExampleState = {
    buttonText: 'Test reducer'
};

export const reducer = (reducerSuffix: string) =>
    produce((draftState, action: Types.IUpdateButtonTextAction): Types.IReduxComponentExampleState | void => {
        switch (action.type) {
            case actionTypes.REDUX_BUTTON_CHANGE_TEXT:
            case actionTypes.REDUX_BUTTON_CHANGE_TEXT + reducerSuffix: {
                draftState.buttonText = action.payload;

                break;
            }

            default: {
                break;
            }
        }
    }, defaultState);
